// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d33c2b91","455":"a3efbcb5","977":"23ec7581"}[chunkId] + ".chunk.js";
};